import axios from "axios";
import {
  onRequest,
  onRequestError,
  onResponse,
  onResponseError,
} from "./api-interceptors";

// export const BASE_URL = process.env.REACT_APP_BASE_URL;
//  export const BASE_URL = `http://localhost:5000`;
export const BASE_URL = `https://ilfk-api.keralasahityaakademi.org`;
// export const BASE_URL = `https://ilfk-test-api.keralasahityaakademi.org`;

const defaultOptions = {
  baseURL: `${BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
};
const instance = axios.create(defaultOptions);
instance.interceptors.request.use(
  (config) => onRequest(config),
  (error) => onRequestError(error)
);
instance.interceptors.response.use(
  (response) => onResponse(response),
  (error) => onResponseError(error)
);
export default instance;
